export const favoriteCategories = [
	{ title: 'Продукты', alias: 'product' },
	// { title: 'Услуга', alias: 'service' },
	// { title: 'Объявление', alias: 'advert' },
	// { title: 'Компания', alias: 'company' },
]


